import { DateTime } from 'luxon';

import {
  MomentTimeFormats,
  serverDateKey,
} from '../../../../../../helpers/Constants';

export interface IBroadcastScheduleValues {
  sendAtDate: DateTime | null;
  sendAtTime: Date | null;
}

export const emptyScheduleValues: IBroadcastScheduleValues = {
  sendAtDate: null,
  sendAtTime: null,
};

// THE DATE AND TIME EXACTLY AS PICKED, SENT WITHOUT ANY TIMEZONE CONVERSION
export const toSendAt = ({
  sendAtDate,
  sendAtTime,
}: IBroadcastScheduleValues) => {
  if (!sendAtDate || !sendAtTime) {
    return null;
  }

  return sendAtDate
    .set({
      hour: sendAtTime.getHours(),
      minute: sendAtTime.getMinutes(),
      second: 0,
      millisecond: 0,
    })
    .toFormat(MomentTimeFormats.fullDate);
};

export const hasSchedule = ({ sendAtDate, sendAtTime }: IBroadcastScheduleValues) =>
  !!(sendAtDate || sendAtTime);

// ONE HALF PICKED WITHOUT THE OTHER CANNOT BE SCHEDULED
export const hasIncompleteSchedule = (values: IBroadcastScheduleValues) =>
  hasSchedule(values) && !toSendAt(values);

// THE STORED DATE AND TIME READ BACK AS IS, WITHOUT ANY TIMEZONE CONVERSION
const toWallClock = (sendAt: string) =>
  DateTime.fromISO(sendAt, { setZone: true }).setZone('local', {
    keepLocalTime: true,
  });

// THE SERVER'S CLOCK, READ THE SAME WAY AS THE STORED SEND TIME SO BOTH ARE QUEBEC TIME
const serverNow = () =>
  toWallClock(localStorage.getItem(serverDateKey) ?? '');

export const isUpcomingSchedule = (sendAt: string | null) =>
  !!sendAt && toWallClock(sendAt) > serverNow();

export const toScheduleValues = (
  sendAt: string | null,
): IBroadcastScheduleValues => {
  if (!sendAt) {
    return emptyScheduleValues;
  }

  const wallClock = toWallClock(sendAt);

  return { sendAtDate: wallClock, sendAtTime: wallClock.toJSDate() };
};
